import React from "react";
import { Briefcase, GraduationCap, Plane, ShieldCheck, TrendingUp } from "lucide-react";
import { useApp } from "@/store/AppContext";

const SERVICES = [
  { key: "Work", icon: Briefcase, title: "Work Visas", desc: "Employer-sponsored pathways and skilled worker relocation." },
  { key: "Study", icon: GraduationCap, title: "Study Visas", desc: "University admissions and post-study work authorization." },
  { key: "Tourist", icon: Plane, title: "Tourist Visas", desc: "Bespoke travel visas and short-term visitor permits." },
  { key: "Permanent Residency", icon: ShieldCheck, title: "Permanent Residency", desc: "Points-based pathways and family sponsorship." },
  { key: "Business", icon: TrendingUp, title: "Business & Investor", desc: "Golden Visas, innovator routes, corporate expansion." },
];

export default function Services() {
  const { openContact } = useApp();

  return (
    <section id="services" data-testid="services-section" className="py-24 bg-app">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-xs uppercase tracking-[0.3em] text-[#C9A961] font-semibold">Our Practice</span>
          <h2 className="font-serif text-3xl sm:text-4xl mt-3 leading-tight text-app">
            Five pathways, one destination — <em className="text-[#C9A961]">yours.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {SERVICES.map(({ key, icon: Icon, title, desc }, i) => (
            <button
              key={title}
              data-testid={`service-card-${i}`}
              onClick={() => openContact({ visa_type: key })}
              className="group text-left card-app rounded-2xl p-6 hover:border-[#C9A961]/60 transition-all hover:-translate-y-1"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl border border-[var(--card-border)] mb-5 group-hover:border-[#C9A961] transition">
                <Icon className="w-5 h-5 text-[#C9A961]" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-xl mb-2 text-app">{title}</h3>
              <p className="text-sm text-app-muted leading-relaxed">{desc}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
